import React, { useEffect, useState } from 'react'
import { FiInstagram } from 'react-icons/fi'
import { RiWhatsappLine } from 'react-icons/ri'
import Lg from '../../assets/tulogger-logo.png'
import {
    Container,
    Inner,
    LogoContainer,
    LogoImgContainer,
    LogoImg,
    LogoText,
    SocialContainer,
    SocialIcon
} from './NavElements'

const Nav = ({ location }) => {

    const [ color, setColor ] = useState('black')

    useEffect(() => {
        location.pathname === '/' ? setColor('black'):
        location.pathname === '/tecnica' ? setColor('white') :
        location.pathname === '/producto' ? setColor('white') :
        location.pathname === '/caracteristicas' && setColor('black')
      }, [location])
        
    return (
        <Container>
            <Inner>
                <LogoContainer
                to='/'
                >
                    <LogoImgContainer>
                        <LogoImg src={Lg}/>
                    </LogoImgContainer>
                    <LogoText color={color}>TuLogger</LogoText>
                </LogoContainer>
                <SocialContainer>
                    <SocialIcon color={color} 
                    href="https://www.instagram.com/tulogger_indumentaria/"
                    target="_blank"
                    rel="noopener noreferrer" 
                    ><FiInstagram /></SocialIcon>
                    <SocialIcon color={color}
                    href="https://wa.me/5491170543029"
                    target="_blank"
                    rel="noopener noreferrer" 
                    ><RiWhatsappLine /></SocialIcon>
                </SocialContainer>
            </Inner>
        </Container>
    )
}

export default Nav